import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: HomePage,
})

// Authenticated users are sent to /dashboard by AuthedDashboardRedirect (see
// DASHBOARD_REDIRECT_ROUTES); this renders only for logged-out visitors.
function HomePage() {
  return <Navigate to="/login" />
}
